import axios from "axios";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import imagenesEditPerfil from "../../assets/imgEditPerfil/imagenesEditPerfil.js";
import imagenesEditProject from "../../assets/imgEditProject/imgEditProject";
import { ValidateEmail } from "../../function/Login";
import { UpdatedInfoCompany } from "../../Interfaces/Company.js";
import { InitialStateCountry, InitialStateDepartment } from "../../Interfaces/departmentsAndmuniti";
import { alertLogin } from "../../Interfaces/Login";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX, faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Cookies from "universal-cookie";
import { useNavigate, Link } from "react-router-dom";

import imgDefault from '../../assets/imgEditPerfil/user.png';
//Input Mask
import InputMask from 'react-input-mask';
import React from "react";
import CompanyEditSkeleton from "../Skeleton/ProfileCompany/editInfoSkeleton";
import IconLoading from "../iconLoading/IconLoading";

// Skeleton IMG Profile
import ImgProfileSkeleton from "../Skeleton/ProfileCompany/imgProfileSkeleton";

import mapboxgl, { FullscreenControl, GeolocateControl, Marker, NavigationControl } from 'mapbox-gl';
// @ts-ignore
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import Input from "../Input/Input";
import ModalResizeImage from "../modals/ModalResizeImage.jsx";
import { showPopup } from "../Utils/Utils.js";

// type
type handleInputChange = ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>

// inicialStateCompany
const initialStateUpdatedInfoCompany = {
    company_name: "",
    company_contact_name: "",
    states_id: "",
    country_id: "",
    gmail: "",
    company_description: "",
    phone: "",
    secondary_phone: "",
    activity_id: "",
    direction: "",
    photo: "",
    Facebook_link: "",
    Instagram_link: "",
    Twitter_link: "",
    Linkedin_link: "",
    id: "",
    plan: "",
    planes_id: "",
    complete_profile_status: 0,
    latitude: 0,
    longitude: 0
}

const initialStateCountry = {
    code: 0,
    id: 0,
    name: ""
}

const initialStateDepartments = {
    code: 0,
    id: 0,
    name: ""
}

const initialStateInput = {
    input: "",
    message: '',
    state: false
}

const initialStateEconomicActivityDefault = {
    id: 0,
    name: ""
}

const EditEmpresa = () => {
    const [lng, setLng] = useState(-88.9426);
    const [lat, setLat] = useState(13.8767);
    const [zoom, setZoom] = useState(9);
    const [UbicacionMap, setUbicacionMap] = useState({
        lng: 0,
        lat: 0
    });

    const [UpdatedCompany, setUpdatedCompany] = useState<UpdatedInfoCompany>(initialStateUpdatedInfoCompany);
    const [Countries, setCountries] = useState<InitialStateCountry[]>([initialStateCountry]);
    const [departments, setDepartments] = useState<InitialStateDepartment[]>([initialStateDepartments]);
    const [alert, setAlert] = useState<alertLogin[]>([initialStateInput]);
    const [initialStateEconomicActivity, setInitialStateEconomicActivity] = useState([initialStateEconomicActivityDefault]);
    const [sendingData, setSendingData] = useState(false);
    const [stateProfileInput, setStateProfileInput] = useState('');
    const [inputPhone, setInputPhone] = useState(false);
    const [modalResizeImage, setModalResizeImage] = useState(false);

    //Input Mask
    const [phone, setPhone] = React.useState<string>("");
    const [MostrarImg, setMostrarImg] = useState(imgDefault);
    const [imgOld, setImgOld] = useState(imgDefault);
    const [closeImg, setCloseImg] = useState(false);
    const [loadImgProfile, setloadImgProfile] = useState(true);

    // Cookies
    const cookies = new Cookies();
    const getSesion = cookies.get('Bearer');
    const navigate = useNavigate();
    const MySwal = withReactContent(Swal);
    const [IsLoading, setIsLoading] = useState(true);

    let fileRefProfile = null;
    const [maskChar, setMaskChar] = useState(null);
    const [characterTextLength, setCharacterTextLength] = useState(500);
    const [lengthText, setLengthText] = useState(0);

    const mapContainer = useRef<any>();
    const map = useRef<any>();
    const markerRef = useRef<any>();

    const uploadProfile = (e: { target: { files: any } }) => {
        const file = e.target.files[0];

        // Validar que sea una imagen
        if (!file.type.startsWith("image/")) {
            MySwal.fire({
                position: 'center',
                icon: 'error',
                title: 'Solo se permiten imágenes',
                text: 'Por favor, sube un archivo de imagen válido.',
                showConfirmButton: true
            });
            return;
        }

        if (file) {
            setUpdatedCompany({ ...UpdatedCompany, photo: URL.createObjectURL(file) });
        }
        
        showPopup(true, setModalResizeImage);
    };

    const reverseImg = () => {
        setloadImgProfile(true);
        setMostrarImg(imgOld);
        setCloseImg(false);
        setTimeout(() => {
            setloadImgProfile(false);
        }, 1000);
    }

    const resetInput = (e: React.MouseEvent<HTMLElement>) => {
        UpdatedCompany.photo = '';
    }

    const handleInputChangeCompany = ({ target: { name, value, id, } }: handleInputChange) => {
        if (name == 'company_description') {
            setLengthText(value.length);
            if (value.length >= 500) {
                setLengthText(500);
                setUpdatedCompany({ ...UpdatedCompany, [name]: value.substring(0, 500) });
            } else {
                setUpdatedCompany({ ...UpdatedCompany, [name]: value });
            }
        } else {
            //Input Mask
            if (name == 'phone' || name == 'secondary_phone') {
                setPhone(value);
            }
            if (name == 'country_id' && value == '3') {
                setInputPhone(true);
            }
            else {
                setInputPhone(false);
            }
            setUpdatedCompany({ ...UpdatedCompany, [name]: value });
        }
    };

    const handleUpdatedInfoValidate = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()

        UpdatedCompany.id = getSesion.id;

        let verifyValues = [
            { name: "name", value: UpdatedCompany.company_name },
            { name: "tel", value: UpdatedCompany.phone },
            { name: "country", value: UpdatedCompany.country_id },
            { name: "address", value: UpdatedCompany.direction },
            { name: "description", value: UpdatedCompany.company_description },
            { name: "stateProfile", value: UpdatedCompany.states_id },
            { name: "economic_activity", value: UpdatedCompany.activity_id },
            { name: "company_contact_name", value: UpdatedCompany.company_contact_name },
        ];

        const phoneRegex = /^\d{4}-?\d{4}$/;
        const validateInputs = ValidateEmail(verifyValues);
        setAlert(validateInputs);

        const isPhoneValid = phoneRegex.test(UpdatedCompany.phone);
        const isSecondaryPhoneValid = UpdatedCompany.secondary_phone
            ? phoneRegex.test(UpdatedCompany.secondary_phone)
            : true;

        if (!isPhoneValid || !isSecondaryPhoneValid) {
            MySwal.fire({
                position: 'center',
                icon: 'error',
                title: 'Formato de teléfono inválido',
                text: 'Teléfono debe tener el formato 9999-9999',
                showConfirmButton: true
            });
            return;
        }

        const state = validateInputs.filter(input => input.state !== false).map((s) => { return false });

        if ((UpdatedCompany.Facebook_link == undefined || UpdatedCompany.Facebook_link == "") &&
            (UpdatedCompany.Instagram_link == undefined || UpdatedCompany.Instagram_link == "") &&
            (UpdatedCompany.Twitter_link == undefined || UpdatedCompany.Twitter_link == "") &&
            (UpdatedCompany.Linkedin_link == undefined || UpdatedCompany.Linkedin_link == "")) {

            MySwal.fire({
                position: 'center',
                icon: 'error',
                title: "Agregar al menos una red social",
                showConfirmButton: false,
                timer: 5500
            });
        } else {
            UpdatedCompany.latitude = UbicacionMap.lat;
            UpdatedCompany.longitude = UbicacionMap.lng;

            if (state.length === 0) {
                if (UpdatedCompany.photo == "" || UpdatedCompany.photo == null || UpdatedCompany.photo == "null" || UpdatedCompany.photo == " null") {
                    MySwal.fire({
                        position: 'center',
                        icon: 'error',
                        title: "Por favor, subir su logotipo al perfil para completar la información de la empresa.",
                        showConfirmButton: false,
                        timer: 5000
                    });
                } else {
                    if (UpdatedCompany.photo.length > 0) {
                        UpdatedCompany.photo = "";
                    }
                    sendData();
                };
            };
        }

        if (UpdatedCompany.photo == "") {
            delete UpdatedCompany['photo'];
        };
    };

    function sendData() {
        setSendingData(true);

        const url = `${process.env.REACT_APP_API_URI}company/complete-profile/${getSesion.id}`;

        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                'ApiToken': `Bearer ${getSesion.token}`
            }
        }

        axios.post(url, UpdatedCompany, config)
            .then(response => {
                if (response.data.Error != "El formato del archivo no es permitido solo se permiten archivos .jpg") {
                    MySwal.fire({
                        position: 'center',
                        icon: 'success',
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 3500
                    }).then(() => {
                        navigate('/perfil-empresa');
                    });

                    setDepartments([initialStateDepartments]);
                    setUpdatedCompany(initialStateUpdatedInfoCompany);
                    setSendingData(false);
                } else {
                    MySwal.fire({
                        position: 'center',
                        icon: 'error',
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 3500
                    });
                    setSendingData(false);
                }
            })
            .catch(err => {
                MySwal.fire({
                    position: 'center',
                    icon: 'error',
                    title: err.response.data.message,
                    showConfirmButton: false,
                    timer: 4500
                });
                setSendingData(false);
            })
    };

    async function getDepartments(id: string) {
        const urlDepartments = `${process.env.REACT_APP_API_URI}state/${id}`;

        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        };

        try {
            const resp = await axios.get(urlDepartments, config);
            if (resp.data.message === "No se encontraron estados o departamentos disponibles.") {
                setDepartments([initialStateDepartments]);
            } else {
                setDepartments(resp.data);
            }
        } catch (err) {
            console.error(err);
        }
    };

    // Get country
    useEffect(() => {
        async function fetchData() {
            const urlCountry = `${process.env.REACT_APP_API_URI}country`;
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            };
            try {
                const resp = await axios.get(urlCountry, config);
                setCountries(resp.data);
            } catch (err) {
                console.error(err);
            }
        };
        fetchData();

        async function getEconomicActivedy() {
            const urlCountry = `${process.env.REACT_APP_API_URI}economic-activity`;
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            };
            try {
                const resp = await axios.get(urlCountry, config);
                setInitialStateEconomicActivity(resp.data);
            } catch (err) {
                console.error(err);
            }
        };
        getEconomicActivedy();
    }, []);

    useEffect(() => {
        async function GetInfoCompany() {
            const idUser = cookies.get('Bearer');
            const urlCountry = `${process.env.REACT_APP_API_URI}company/profile/${idUser.id}`;

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'ApiToken': `Bearer ${getSesion.token}`
                }
            };

            try {
                const resp = await axios.get(urlCountry, config);

                let imgCompany = "";
                if (resp.data.photo == null || resp.data.photo == "") {
                    imgCompany = imgDefault;
                } else {
                    imgCompany = `${process.env.REACT_APP_PHOTO_URI}company-image/${resp.data.photo}`;
                }

                setMostrarImg(imgCompany);
                setImgOld(imgCompany);
                setTimeout(() => {
                    setloadImgProfile(false);
                }, 1000);

                let facebook = "";
                let instagram = "";
                let twitter = "";
                let linkedin = "";

                if (resp.data.social_media_links !== null && resp.data.social_media_links !== undefined) {
                    if (resp.data.social_media_links.facebook_link != null || resp.data.social_media_links.facebook_link != "") {
                        facebook = resp.data.social_media_links.facebook_link;
                    };

                    if (resp.data.social_media_links.instagram_link != null || resp.data.social_media_links.instagram_link != "") {
                        instagram = resp.data.social_media_links.instagram_link;
                    };

                    if (resp.data.social_media_links.twitter_link != null || resp.data.social_media_links.twitter_link != "") {
                        twitter = resp.data.social_media_links.twitter_link;
                    };

                    if (resp.data.social_media_links.linkedin_link != null || resp.data.social_media_links.linkedin_link != "") {
                        linkedin = resp.data.social_media_links.linkedin_link;
                    };
                }

                if (resp.data.company_description != null) {
                    setLengthText((resp.data.company_description).length);
                }

                let listInfo = {
                    company_name: resp.data.company_name,
                    company_contact_name: resp.data.company_contact_name,
                    states_id: resp.data.status,
                    country_id: resp.data.country_id,
                    gmail: resp.data.email,
                    company_description: resp.data.company_description,
                    phone: resp.data.phone,
                    secondary_phone: resp.data.secondary_phone,
                    activity_id: resp.data.activity_id,
                    direction: resp.data.direction,
                    latitude: resp.data.latitude,
                    longitude: resp.data.longitude,
                    photo: resp.data.photo,
                    Facebook_link: facebook,
                    Instagram_link: instagram,
                    Twitter_link: twitter,
                    Linkedin_link: linkedin,
                    id: resp.data.user_id,
                    plan: "",
                    planes_id: "",
                    complete_profile_status: resp.data.complete_profile_status
                };

                // Set initial map position from backend data
                const initialLat = resp.data.latitude || 13.8767;
                const initialLng = resp.data.longitude || -88.9426;

                setLat(initialLat);
                setLng(initialLng);
                setUbicacionMap({
                    lng: initialLng,
                    lat: initialLat
                });

                switch (resp.data.complete_profile_status) {
                    case 1:
                        setStateProfileInput('En validación');
                        break;
                    case 2:
                        setStateProfileInput('Incompleto');
                        break;
                    case 3:
                        setStateProfileInput('Verificado');
                        break;
                    case 4:
                        setStateProfileInput('Rechazado');
                        break;
                    default:
                        setStateProfileInput('Perfil Empresa');
                        break;
                };

                setUpdatedCompany(listInfo);

                if (resp.data.country_id == '3') {
                    setInputPhone(true);
                };

                setIsLoading(false);
            } catch (err) {
                console.error(err);
            }
        };
        GetInfoCompany();

        mapboxgl.accessToken = 'pk.eyJ1IjoiZ2Vvcmdlc3YiLCJhIjoiY2s5YTJjaGV0MDB0NzNsbXFuM3EyeThnYSJ9.F7uxDu4RAFlHz61e2cxNjw';

        const initializeMap = () => {
            if (map.current) return; // initialize map only once

            map.current = new mapboxgl.Map({
                container: mapContainer.current,
                style: 'mapbox://styles/mapbox/streets-v12',
                center: [lng, lat],
                zoom: zoom,
                minZoom: 2,
                maxZoom: 24
            });

            // Add marker for the initial position
            if (markerRef.current) {
                markerRef.current.remove();
            }

            markerRef.current = new Marker()
                .setLngLat([lng, lat])
                .addTo(map.current);

            const geocoder = new MapboxGeocoder({
                accessToken: "pk.eyJ1IjoiZ2Vvcmdlc3YiLCJhIjoiY2s5YTJjaGV0MDB0NzNsbXFuM3EyeThnYSJ9.F7uxDu4RAFlHz61e2cxNjw",
                countries: 'sv',
                bbox: [-90.0955545723, 13.1490168319, -87.7235029772, 14.4241327987],
                filter: (item: any) => {
                    return item.context.map((i: { id: string; text: string; }) => {
                        return (i.id.split('.').shift() === 'country' && i.text === 'El Salvador');
                    }).reduce((acc: any, cur: any) => {
                        return acc || cur;
                    });
                },
                placeholder: "Buscar",
            });

            const locateU = new GeolocateControl({
                positionOptions: {
                    enableHighAccuracy: true
                },
                trackUserLocation: true
            });

            map.current.on('click', (e: { lngLat: { lng: number; lat: number; }; }) => {
                setUbicacionMap({
                    lng: e.lngLat.lng,
                    lat: e.lngLat.lat
                });

                if (markerRef.current) {
                    markerRef.current.remove();
                }

                markerRef.current = new Marker()
                    .setLngLat([e.lngLat.lng, e.lngLat.lat])
                    .addTo(map.current);

                map.current.flyTo({
                    center: [e.lngLat.lng, e.lngLat.lat],
                    zoom: 15
                });
            });

            geocoder.on('result', (ev: any) => {
                setUbicacionMap({
                    lng: ev.result.geometry.coordinates[0],
                    lat: ev.result.geometry.coordinates[1]
                });

                if (markerRef.current) {
                    markerRef.current.remove();
                }

                markerRef.current = new Marker()
                    .setLngLat([ev.result.geometry.coordinates[0], ev.result.geometry.coordinates[1]])
                    .addTo(map.current);
            });

            locateU.on('geolocate', (e: any) => {
                const lon = e.coords.longitude;
                const lat = e.coords.latitude;
                const position = [lon, lat];

                setUbicacionMap({
                    lng: lon,
                    lat: lat
                });

                if (markerRef.current) {
                    markerRef.current.remove();
                }

                markerRef.current = new Marker()
                    .setLngLat([lon, lat])
                    .addTo(map.current);

                map.current.flyTo({
                    center: position,
                    zoom: 9
                });
            });

            map.current.addControl(geocoder);
            map.current.addControl(new NavigationControl());
            map.current.addControl(new FullscreenControl());
            map.current.addControl(locateU);
        };

        const timer = setTimeout(() => {
            initializeMap();
        }, 2500);

        return () => clearTimeout(timer);
    }, [lat, lng]);

    return (
        <>
            {IsLoading && <CompanyEditSkeleton />}
            {!IsLoading &&
                <div className="bg-gradient-to-b from-Light-purple via-turquoise to-Dark-purple min-h-screen">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                        {/* Botón de retroceso mejorado */}
                        <button
                            onClick={() => window.history.go(-1)} 
                            className="flex items-center text-white hover:text-Yellow transition-colors mb-6"
                        >
                            <FontAwesomeIcon icon={faArrowLeft} className="w-6 h-6 mr-2" />
                            <span className="text-lg font-medium">Volver</span>
                        </button>

                        <form onSubmit={handleUpdatedInfoValidate} className="rounded-lg overflow-hidden">
                            {/* Encabezado */}
                            <div className="px-6 py-4">
                                <h2 className="text-2xl md:text-3xl font-bold text-Yellow text-center">
                                    Editar perfil de empresa
                                </h2>
                            </div>

                            <div className="p-6 md:p-8 flex flex-col md:flex-row gap-8">
                                {/* Sección de imagen de perfil */}
                                <div className="w-full md:w-1/3 lg:w-1/4 flex flex-col items-center">
                                    <div className="relative mb-4">
                                        {closeImg && (
                                            <button 
                                                className="absolute -top-2 -right-2 bg-white rounded-full p-1 shadow-md z-10 hover:bg-gray-100"
                                                onClick={reverseImg}
                                            >
                                                <FontAwesomeIcon icon={faX} className="text-red-600 w-4 h-4" />
                                            </button>
                                        )}
                                        <label htmlFor="photo" className="cursor-pointer">
                                            {loadImgProfile ? (
                                                <ImgProfileSkeleton />
                                            ) : (
                                                <div className="relative group">
                                                    <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-Yellow">
                                                        <img 
                                                            className="w-full h-full object-cover" 
                                                            src={MostrarImg} 
                                                            alt="Imagen de perfil" 
                                                        />
                                                    </div>
                                                    <div className="absolute inset-0 bg-black bg-opacity-50 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                                                        <span className="text-white font-medium">Editar foto</span>
                                                    </div>
                                                </div>
                                            )}
                                        </label>
                                        <input
                                            type="file"
                                            className="hidden"
                                            id="photo"
                                            onChange={uploadProfile}
                                        />
                                    </div>

                                    <div className="text-center">
                                        <h5 className="text-Yellow font-medium">Estado del perfil</h5>
                                        <p className="text-white">{stateProfileInput}</p>
                                    </div>
                                </div>

                                {/* Sección de formulario */}
                                <div className="w-full md:w-2/3 lg:w-3/4">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        {/* Nombre de la empresa */}
                                        <div className="col-span-1 md:col-span-2">
                                            <label className="block text-white font-medium mb-1">
                                                Nombre de la empresa*
                                            </label>
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                name="company_name"
                                                value={UpdatedCompany.company_name}
                                                onChange={handleInputChangeCompany}
                                            />
                                            {alert.filter(input => input.input == "name" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Correo electrónico */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                Correo electrónico
                                            </label>
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent disabled:cursor-not-allowed"
                                                name="gmail"
                                                value={UpdatedCompany.gmail}
                                                disabled
                                            />
                                        </div>

                                        {/* Actividad económica */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                Actividad económica*
                                            </label>
                                            <select
                                                name="activity_id"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                value={UpdatedCompany.activity_id}
                                                onChange={handleInputChangeCompany}
                                            >
                                                <option value="">Seleccione una actividad</option>
                                                {initialStateEconomicActivity.map((Activity) => (
                                                    <option key={Activity.id} value={Activity.id}>
                                                        {Activity.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {alert.filter(input => input.input == "economic_activity" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* País */}
                                        <div>
                                            <label className="block text-white font-medium mb-1">
                                                País*
                                            </label>
                                            <select
                                                name="country_id"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                value={UpdatedCompany.country_id}
                                                onChange={handleInputChangeCompany}
                                            >
                                                <option value="">Seleccione un país</option>
                                                {Countries.map((country) => (
                                                    <option key={country.id} value={country.id}>
                                                        {country.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {alert.filter(input => input.input == "country" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Persona de contacto */}
                                        <div className="col-span-1 md:col-span-2">
                                            <label className="block text-white font-medium mb-1">
                                                Persona de contacto*
                                            </label>
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                name="company_contact_name"
                                                value={UpdatedCompany.company_contact_name}
                                                onChange={handleInputChangeCompany}
                                            />
                                            {alert.filter(input => input.input == "company_contact_name" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                        </div>

                                        {/* Teléfono principal */}
                                        <div>
                                            <Input
                                                type="text"
                                                mask={'9999-9999'}
                                                label="Teléfono principal*"
                                                name="tel"
                                                required={false}
                                                alert={alert}
                                                onChange={(e: { target: { value: React.SetStateAction<string>; }; }) => {
                                                    setUpdatedCompany({
                                                        ...UpdatedCompany,
                                                        phone: e.target.value as string
                                                    });
                                                    setPhone(e.target.value);
                                                }}
                                                value={UpdatedCompany.phone}
                                                placeholder="Ej: 1234-5678"
                                                tooltip="Ingrese un número de teléfono válido"
                                                loading={false}
                                                id="tel"
                                                maxLength={false}
                                                decimals={0}
                                                className="input-class"
                                                onBlur={() => {}}
                                                onFocus={() => {}}
                                            />
                                        </div>

                                        {/* Teléfono secundario */}
                                        <div>
                                            <Input
                                                type="text"
                                                mask={'9999-9999'}
                                                label="Teléfono secundario"
                                                name="tel2"
                                                required={false}
                                                alert={alert}
                                                onChange={(e: { target: { value: React.SetStateAction<string>; }; }) => {
                                                    setUpdatedCompany({
                                                        ...UpdatedCompany,
                                                        secondary_phone: e.target.value as string
                                                    });
                                                    setPhone(e.target.value);
                                                } }
                                                value={UpdatedCompany.secondary_phone}
                                                placeholder="Ej: 1234-5678" 
                                                tooltip={undefined} 
                                                loading={undefined} 
                                                id={undefined} 
                                                maxLength={undefined} 
                                                decimals={undefined} 
                                                className={undefined} 
                                                onBlur={undefined} 
                                                onFocus={undefined}                                           
                                            />
                                        </div>

                                        {/* Dirección */}
                                        <div className="col-span-1 md:col-span-2">
                                            <label className="block text-white font-medium mb-1">
                                                Dirección*
                                            </label>
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent"
                                                name="direction"
                                                value={UpdatedCompany.direction}
                                                onChange={handleInputChangeCompany}
                                            />
                                            {alert.filter(input => input.input == "address" && input.state === true).map((message, index) => (
                                                <p key={index} className="text-red-500 text-sm mt-1">{message.message}</p>
                                            ))}
                                            
                                            {/* Mapa */}
                                            <div className="mt-4">
                                                <label className="block text-white font-medium mb-2">
                                                    Ubicación en el mapa
                                                </label>
                                                <div 
                                                    ref={mapContainer} 
                                                    className="map-container h-64 w-full rounded-lg border border-gray-300 overflow-hidden"
                                                />
                                                <p className="text-sm text-gray-500 mt-2">
                                                    Haz clic en el mapa para seleccionar la ubicación exacta
                                                </p>
                                            </div>
                                        </div>

                                        {/* Descripción */}
                                        <div className="col-span-1 md:col-span-2">
                                            <label className="block text-white font-medium mb-1">
                                                Descripción de la empresa*
                                            </label>
                                            <textarea
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-Yellow focus:border-transparent h-40"
                                                name="company_description"
                                                value={UpdatedCompany.company_description}
                                                onChange={handleInputChangeCompany}
                                            />
                                            <div className="flex justify-between mt-1">
                                                <span className="text-sm text-gray-500">
                                                    {lengthText} / {characterTextLength} caracteres
                                                </span>
                                                {alert.filter(input => input.input == "description" && input.state === true).map((message, index) => (
                                                    <span key={index} className="text-red-500 text-sm">{message.message}</span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Redes sociales */}
                                    <div className="mt-8">
                                        <div className="flex items-center my-6">
                                            <div className="flex-1 border-t border-Yellow"></div>
                                            <span className="px-4 text-Yellow font-medium">Redes sociales</span>
                                            <div className="flex-1 border-t border-Yellow"></div>
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            {/* Facebook */}
                                            <div>
                                                <label className="block text-white font-medium mb-1">
                                                    Facebook
                                                </label>
                                                <div className="flex items-center">
                                                    <span className="bg-blue-600 text-white px-3 py-2 rounded-l-lg">
                                                        fb.com/
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="flex-1 px-4 py-2 rounded-r-lg"
                                                        name="Facebook_link"
                                                        value={UpdatedCompany.Facebook_link}
                                                        onChange={handleInputChangeCompany}
                                                        placeholder="usuario"
                                                    />
                                                </div>
                                            </div>

                                            {/* Instagram */}
                                            <div>
                                                <label className="block text-white font-medium mb-1">
                                                    Instagram
                                                </label>
                                                <div className="flex items-center">
                                                    <span className="bg-pink-600 text-white px-3 py-2 rounded-l-lg">
                                                        @
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="flex-1 px-4 py-2 rounded-r-lg"
                                                        name="Instagram_link"
                                                        value={UpdatedCompany.Instagram_link}
                                                        onChange={handleInputChangeCompany}
                                                        placeholder="usuario"
                                                    />
                                                </div>
                                            </div>

                                            {/* Twitter */}
                                            <div>
                                                <label className="block text-white font-medium mb-1">
                                                    Twitter
                                                </label>
                                                <div className="flex items-center">
                                                    <span className="bg-blue-400 text-white px-3 py-2 rounded-l-lg">
                                                        @
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="flex-1 px-4 py-2 rounded-r-lg"
                                                        name="Twitter_link"
                                                        value={UpdatedCompany.Twitter_link}
                                                        onChange={handleInputChangeCompany}
                                                        placeholder="usuario"
                                                    />
                                                </div>
                                            </div>

                                            {/* LinkedIn */}
                                            <div>
                                                <label className="block text-white font-medium mb-1">
                                                    LinkedIn
                                                </label>
                                                <div className="flex items-center">
                                                    <span className="bg-blue-700 text-white px-3 py-2 rounded-l-lg">
                                                        linkedin.com/company/
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="flex-1 px-4 py-2 rounded-r-lg"
                                                        name="Linkedin_link"
                                                        value={UpdatedCompany.Linkedin_link}
                                                        onChange={handleInputChangeCompany}
                                                        placeholder="usuario"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Botón de guardar */}
                                    <div className="mt-10 flex justify-center">
                                        <button
                                            type="submit"
                                            className="w-full md:w-1/2 lg:w-1/3 py-3 bg-Yellow hover:bg-amber-600 text-white font-medium rounded-lg shadow-md transition duration-300"
                                            disabled={sendingData}
                                        >
                                            {!sendingData ? (
                                                "Guardar cambios"
                                            ) : (
                                                <div className="flex items-center justify-center">
                                                    <IconLoading />
                                                    <span className="ml-2">Guardando...</span>
                                                </div>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            }
            
            {modalResizeImage && (
                <ModalResizeImage
                    img={UpdatedCompany.photo}
                    setShowModalResizeImage={setModalResizeImage}
                    funVaciarFoto={reverseImg}
                    showPopup={showPopup}
                    setFormulario={setUpdatedCompany}
                    formulario={UpdatedCompany}
                    name={"photo"}
                    fun={(e: any) => {
                        setUpdatedCompany({
                            ...UpdatedCompany,
                            photo: e
                        });
                        let imageUrl = URL.createObjectURL(e);
                        setloadImgProfile(true);
                        setMostrarImg(imageUrl);
                        
                        setTimeout(() => {
                            setCloseImg(true);
                            setloadImgProfile(false);
                        }, 1000);
                    }}
                />
            )}
        </>
    )
}

export default EditEmpresa;